// Werklijst van de platformbeheerder (verzoek oprichter 2026-09-25; DESIGN.md §8.WL). Alleen de
// schermteksten: de punten zelf staan in docs/werklijst.json (Nederlands, gewone taal). Toon:
// je-vorm, korte zinnen, geen jargon.
export const appWerklijstNl = {
    title: 'Werklijst',
    /** {when} = "vr 25 sep 18:15". */
    subtitle: 'Alleen voor jou als beheerder · bijgewerkt {when}',
    progress: '{done} van {total} klaar',
    progressLabel: 'Voortgang: {done} van {total} punten klaar',
    /** Schermlezer: naam van de voortgangskaart (niet gelijk aan de paginatitel). */
    progressRegion: 'Voortgang',
    status: {
        waiting_on_you: 'Wacht op jou',
        in_progress: 'Bezig',
        planned: 'Gepland',
        later: 'Later',
        done: 'Klaar',
    },
    filterAll: 'Alles',
    /** Schermlezer: naam van de rij filterknoppen. */
    filterLabel: 'Laat zien',
    /** Regel onder de filterknoppen zolang er niet op Alles staat; {status} = "Klaar". */
    filterActive: 'Je ziet nu alleen: {status}',
    showAll: 'Alles tonen',
    needsYou: 'Wat ik van jou nodig heb',
    needsYouCount: {
        one: 'Er wacht één punt op jou.',
        other: 'Er wachten {count} punten op jou.',
    },
    /** Schermlezer, voor de titel in "Wat ik van jou nodig heb": "Bekijk: Echte e-mail versturen". */
    show: 'Bekijk',
    doneAt: 'Klaar op {when}',
    whatIsIt: 'Wat is het?',
    yourAction: 'Wat moet jij doen?',
    /** Schermlezer bij het "#17"-labeltje. */
    numberLabel: 'punt {n} uit je feedback',
    groupCount: '{done} van {total} klaar',
    emptyTitle: 'Niets met deze stand',
    emptyBody: 'Kies hierboven een andere stand, of Alles.',
    unavailable: 'De werklijst is nu even niet te lezen. Probeer het straks opnieuw.',
};
//# sourceMappingURL=werklijstApp.nl.js.map